import { render, staticRenderFns } from "./myiframe.vue?vue&type=template&id=63b67501&scoped=true&"
import script from "./myiframe.vue?vue&type=script&lang=js&"
export * from "./myiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b67501",
  null
  
)

export default component.exports